/**
 * The reviews shown at the signup gate.
 *
 * They are the same reviews the home page carries, from the same file, so
 * there is one copy of each customer's words in this codebase and no chance
 * of a second, edited one. Nothing here is trimmed, summarized or
 * re-headlined, and no rating is stored or shown: this product has published
 * invented ones before.
 *
 * All five, in a row under everything. They used to be three under the
 * signup card; a rail across the whole gate gives them room without any of
 * them shouting.
 */
import { testimonials, type Testimonial } from '@/content/home'

/*
  Ordered by what they say: the ones that say HubSpot in a customer's own
  voice come first, which is worth more here than us saying it again, then a
  real person answering support, then the rest.
*/
const GATE_PROOF_WHO = ['Eimer, C.', 'Orecchio, D.', 'Kerr, D.', 'Wilkinson, M.', 'Garcia, J.']

/** Where they come from. HubSpot's own property, so it is worth naming. */
export const GATE_PROOF_SOURCE = 'From our reviews on the HubSpot marketplace'

export function gateProof(): Testimonial[] {
  return GATE_PROOF_WHO
    .map(who => testimonials.find(review => review.who === who))
    .filter((review): review is Testimonial => Boolean(review))
}
